
import { Game } from "@/models/Game";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { Component, Vue, Prop } from "vue-property-decorator";
import ActionBoxTab from "./ActionBoxTab.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: { ActionBoxTab },
})
class ActionBox extends Vue {
  @Prop({ default: false }) readonly contentData!: ActionList;
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: false }) readonly showTextBox!: boolean;
  @Prop({ default: "" }) readonly textBoxData!: string;
  @Prop({ default: "" }) readonly placeholder!: string;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly showGameStatus!: boolean;
  @Prop({ default: "" }) readonly mapPoiKey!: string;
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: "" }) readonly questKey!: string;

  get getActionList(): ActionList {
    if (this.contentData === undefined) {
      return {} as ActionList;
    }
    return this.contentData;
  }

  onTextChange(): void {
    var contentData = {
      contentData: this.getActionList,
      txt: this.textBoxData,
    };
    this.$emit("update", contentData);
  }

  update(contentData: any): void {
    if (this.showTextBox) {
      contentData.txt = this.textBoxData;
    }
    this.$emit("update", contentData);
  }
  deleteAction(contentData: any): void {
    if (this.showTextBox) {
      contentData.txt = this.textBoxData;
    }
    this.$emit("deleteAction", contentData);
  }

  defaultMessage(): string {
    if (this.title === "FAILURE") {
      return "Failed";
    } else if (this.title === "SUCCESS") {
      return "Success";
    } else {
      return "Opps";
    }
  }

  created(): void {
    this.$store.dispatch("gameStore/getGameTypes", "quest");
  }

  @Validations()
  validations = {
    textBoxData: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(160),
    },
  };
}

export default ActionBox;
